export const validateNIF = (value: string | undefined) => {
    if (!value || typeof value !== "string" || value.length !== 9) return false;

    let sumAux = 0;
    for (let i = 9; i >= 2; i--) {
        sumAux += i * (parseInt(value[value.length - i]) || 0);
    }

    const module = sumAux % 11;

    // Get the eight first numbers
    const NIFwithoutLastDigit = value.slice(0, value.length - 1);

    if (module === 0 || module === 1) {
        return `${NIFwithoutLastDigit}0` === value;
    } else {
        return `${NIFwithoutLastDigit}${11 - module}` === value;
    }
};

export function convertToCurrency(str: string): number {
    return parseFloat(str?.replace(/\ /g, '')?.replace(',', '.'));
}

export const ageValidator = (dateInput: typeof Date | undefined, minAge: number | undefined) => {

    const match = dateInput.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!match) return false;

    const [, dd, mm, yyyy] = match;
    const day = parseInt(dd, 10);
    const month = parseInt(mm, 10) - 1;
    const year = parseInt(yyyy, 10);

    const birthDate = new Date(year, month, day);
    if (
        birthDate.getFullYear() !== year ||
        birthDate.getMonth() !== month ||
        birthDate.getDate() !== day
    ) {
        return false;
    }

    const today = new Date();
    const ageDate = new Date(year + 18, month, day);

    return (ageDate <= today);

}